import React, { useEffect, useContext } from 'react';
import {
  Box, Button, Container, Divider, IconButton, Skeleton,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowBackRounded } from '@mui/icons-material';
import Images from '../../../../Configs/images';
import AlertContext from '../../../../Context/AlertContext';
import { getSubscriptions } from '../../../../Redux/Models/master';
import { formatNum } from '../../../../Utils/helpers';
import Elements from '../../../Elements';
import { getUserData } from '../../../../Utils/storages';

export default function SubscriptionPackage({
  classes,
  subscriptions,
  isLoadingSubscriptions,
  errorSubscriptions,
  subscriptionsMessage,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getUserData() || {};
  const { openAlert } = useContext(AlertContext);

  const getData = () => {
    dispatch(getSubscriptions());
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (errorSubscriptions) {
      openAlert({
        severity: 'error',
        message: subscriptionsMessage || 'Something went wrong',
      });
    }
  }, [errorSubscriptions]);

  const renderPackages = () => {
    if (isLoadingSubscriptions) {
      return [1, 2].map((idx) => (
        <Box className="package-box mt-4" key={idx}>
          <div className="regular" />
          <div className="detail-container">
            <div className="flex gap-16 mt-2 align-items-center">
              <Skeleton variant="circular" width={42} height={42} />
              <Skeleton variant="text" width={100} height={24} />
            </div>

            <Divider sx={{ my: 2 }} />

            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} />

            <Divider sx={{ my: 2 }} />

            <div className="flex mt-1 align-items-center space-between">
              <div className="weight-700 s-16">
                <Skeleton variant="rectangular" className="rounded" width={120} height={24} />
              </div>
              <Skeleton variant="rectangular" className="rounded" width={100} height={32} />
            </div>
          </div>
        </Box>
      ));
    }
    if (subscriptions.length) {
      return subscriptions.filter((sub) => sub.name !== 'Business to Business (B2B)').map((subscription) => (
        <Box className="package-box mt-4" key={subscription.id} sx={{ display: userData.subscription === subscription.name ? 'none' : 'block' }}>
          <div className="regular" />
          <div className="detail-container">
            <div className="flex gap-16 mt-2 align-items-center">
              <img alt="star" src={subscription.images[0]} width="42" height="42" className="circle" />
              <div className="weight-700 s-16">{subscription.name}</div>
            </div>

            <Divider sx={{ my: 2 }} />

            {subscription.package_benefit?.map((benefit) => (
              <li className="mt-1" key={benefit}>{benefit}</li>
            ))}

            <Divider sx={{ my: 2 }} />

            <div className="flex mt-1 align-items-center space-between">
              <div className="weight-700 s-16">
                ₣
                {formatNum(Number(subscription.price?.unit_amount) / 100)}
                .00
                /month
              </div>
              <Button className="btn-outlined" onClick={() => navigate(subscription.id)}>Know More</Button>
            </div>
          </div>
        </Box>
      ));
    }

    return null;
  };

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <IconButton onClick={() => navigate(-1)} sx={{ mt: 2, ml: 2 }}>
          <ArrowBackRounded />
        </IconButton>
        <Container className="center">
          <img src={Images.Logo} alt="box pack" className="mt-2" />
          <h4 className="mt-4">Choose your package</h4>
          <div className="s-16 mt-3 height-14">
            Choose a subscription package that fits your needs!
          </div>
        </Container>

        <Container>
          {renderPackages()}
        </Container>

        {/* <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth>See Boxpack subcription package</Button>
          </Container>
        </div> */}
      </div>
    </Elements.PageBase>
  );
}
